import React from "react";
import styles from "./styles.module.css";
import imgLogo from "../../images/fenix_azul_principal.png"

export const CardInform = ({ title, description, image, imgAlt }) => {
  return (
    <section className={styles.cardInform}>
      <h1 className={styles.cardIform__title}>{title}</h1>
      <div className={styles.cardInform__descript}>
        <span>{description}</span>
      </div>
      <div>
        <img src={image} alt={imgAlt} className={styles.cardInform__img} />
      </div>
      <div className={styles.cardInform__logo}>
        <img src={imgLogo} alt="Logo Taxation Mind"/>
      </div>
    </section>
  );
};

